<template>
    <div class="flex gap-3">
        <img :src="data.icon" class="item__icon" />
        <span class="item__title font-bold">
            {{ data.name }}
        </span>
    </div>
    <div v-for="attr in data.description" :key="attr.name" class="py-1">
        <span class="whitespace-pre-line"> {{ attr.name }}: {{ attr.value }} </span>
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});
</script>

<style lang="scss" scoped>
.item__icon {
    width: 36px;
    height: 36px;
}

.item__title {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;

    white-space: normal;
    -webkit-line-clamp: 2;
}
</style>
